import type { MemberApi } from "../../api/MemberApi";
import type { AuthTokens } from "../../generated/dto/AuthTokens";
import type { CompleteMemberProfile } from "../../generated/dto/CompleteMemberProfile";
import type { CompleteMemberRegistration } from "../../generated/dto/CompleteMemberRegistration";
import type { MemberAgreementStatus } from "../../generated/dto/MemberAgreementStatus";
import type { MemberAgreementStatuses } from "../../generated/dto/MemberAgreementStatuses";
import type { MemberRequiredAgreementsRequest } from "../../generated/dto/MemberRequiredAgreementsRequest";
import type { MemberSignAgreementRequest } from "../../generated/dto/MemberSignAgreementRequest";
import type { ProtoLoginResult } from "../../generated/dto/ProtoLoginResult";
import type { RecipientLookupRequest } from "../../generated/dto/RecipientLookupRequest";
import type { RecipientLookupResult } from "../../generated/dto/RecipientLookupResult";

export class MemberFrontendService {
  constructor(private readonly api: MemberApi) {}
  async completeProfileMember(request: CompleteMemberProfile): Promise<AuthTokens> {
    return this.api.completeProfileMember(request)
  }
  async completeRegistrationMember(request: CompleteMemberRegistration): Promise<AuthTokens> {
    return this.api.completeRegistrationMember(request)
  }
  async createMemberPublic(email: string): Promise<AuthTokens> {
    return this.api.createMemberPublic(email)
  }
  async createMemberFromProtoMember(email: string): Promise<ProtoLoginResult> {
    return this.api.createMemberFromProtoMember(email)
  }
  async lookupRecipientMember(request: RecipientLookupRequest): Promise<RecipientLookupResult> {
    return this.api.lookupRecipientMember(request)
  }
  async requiredAgreementsMember(request: MemberRequiredAgreementsRequest): Promise<MemberAgreementStatuses> {
    return this.api.requiredAgreementsMember(request)
  }
  async signAgreementMember(request: MemberSignAgreementRequest): Promise<MemberAgreementStatus> {
    return this.api.signAgreementMember(request)
  }
}
